export default "__VITE_ASSET__79928538__"